module.exports = __webpack_public_path__ + "img/gold.0255c7f6.svg";